var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"service-card"},[_c('div',{staticClass:"service-img"},[_c('img',{attrs:{"src":_vm.needObj.defImg,"alt":""}})]),_vm._v(" "),_c('h3',{staticClass:"service-title"},[_vm._v(_vm._s(_vm.needObj.title))]),_vm._v(" "),_c('div',{staticClass:"service-text"},[_vm._v("\n        "+_vm._s(_vm.needObj.text)+"\n    ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }